module.exports = __webpack_public_path__ + "static/media/my-bid.e3e87e27.svg";